import { GridToolbarContainer, GridToolbarColumnsButton } from '@mui/x-data-grid';
import { WsTypoColors, WsTypography } from 'wisestep-base';

export const CustomToolbar = () => (
  <GridToolbarContainer>
    <GridToolbarColumnsButton />
  </GridToolbarContainer>
);

export const CustomLabel = () => (
  <GridToolbarContainer sx={{ marginLeft: 1 }}>
    <WsTypography bold color={WsTypoColors.PRIMARY}>
      Archived fee arrangement
    </WsTypography>
  </GridToolbarContainer>
);
